import { CommonModule } from '@angular/common';
import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ColeccionistasService } from './coleccionistas.service';
import { Observable, Subscription } from 'rxjs';
import { Coleccionista, ColeccionistasResponse, DataColeccionista } from 'app/models/coleccionitas.model';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { environment as env } from 'environments/environments';
import { MatDialog } from '@angular/material/dialog';
import { FormColeccionistaComponent } from './form-coleccionista/form-coleccionista.component';
import { FormsModule } from '@angular/forms';
import { ArrowBackComponent } from "../../GlobalComponents/arrow-back.component";
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { ParamsColeccionistas } from './models/params-coleccionista.model';
import { UtilsService } from 'app/modules/utils-service';
import { FiltroColeccionistasComponent } from "./filtro-coleccionistas/filtro-coleccionistas.component";
import { StatusStickerComponent } from 'app/modules/GlobalComponents/status sticker.component';
import { FormActualizarColeccionistaComponent } from './form-actualizar-coleccionista/form-actualizar-coleccionista.component';
import { HasPermissionsDirective } from 'app/core/directives/has-permissions-module';

@Component({
    selector: 'coleccionista',
    templateUrl: 'coleccionistas.component.html',
    imports: [
        CommonModule, 
        MatButtonModule,
        MatIconModule,
        MatTableModule, 
        MatMenuModule, 
        FormsModule,
        MatPaginatorModule,

        //Components
        ArrowBackComponent, 
        FiltroColeccionistasComponent, 
        StatusStickerComponent,
        HasPermissionsDirective
    
    ]
})

export class ColeccionistasComponent implements OnInit {
    seccion_prehispanica= env.TIPOLOGIA_ID_SECCION_PREHISPANICA
    seccion_hispanica_republicana= env.TIPOLOGIA_ID_SECCION_HISPANICA_REPUBLICANA
    seccion_bienes_inmuebles= env.TIPOLOGIA_ID_SECCION_BIENES_INMUEBLES
    paramsColeccionista:Partial<ParamsColeccionistas>
    private coleccionistasSub: Subscription;

    @ViewChild(MatPaginator) paginator: MatPaginator;
        
    // paginator variables
    public totalResultItems = 0;
    public pageSize= 10;
    public isLoadingResults = true; 
    
    coleccionistas$: Observable<ColeccionistasResponse>
    colecionistasTableColumns: string[] = [
        'id-coleccionista',
        'nombre',
        'correo',
        'coleccion',
        'departamento',
        'seccion',
        'total-bienes',
        'acciones',

    ];

    constructor(
        private coleccionistasService:ColeccionistasService,
        private router: Router,
        public dialog: MatDialog,
        private utilsService: UtilsService
    ) { 
        this.paramsColeccionista = {inicio:0, max:10};
        this.getColeccionistas(this.paramsColeccionista)
        this.coleccionistas$= this.coleccionistasService.coleccionistas$

        
    }

    ngOnInit() {
        this.coleccionistasSub = this.coleccionistas$.subscribe(response => {
            this.totalResultItems = response?.total;
        });
     }

    ngAfterViewInit() {
        if (this.paginator) {
            this.paginator.page.subscribe(() => {
                const pageIndex = this.paginator.pageIndex;
                let start = pageIndex * this.pageSize;
                let end = start + this.pageSize;
                const currentFilters = this.coleccionistasService.coleccionistasFilterParmasValue;

            // Validar si existen filtros 
            if (currentFilters) {
                const newParams = {
                ...currentFilters,
                inicio: start,
                max: end
                };

                this.getColeccionistas(newParams);
            } else {
                // Si no hay filtros, hacer la llamada solo con paginación
                const newParams = {
                inicio: start,
                max: end
                };

                this.getColeccionistas(newParams);
            }
            });
        }
     }

    agregarColeccionista(){
        const dialog = this.dialog.open(FormColeccionistaComponent, {
                    panelClass: ['w-full', 'md:w-5/12'],
                    height: 'calc(100vh - 4rem)',
                    disableClose:true
                })
        
                dialog.afterClosed().subscribe((result:boolean)=>{
                    if(result){
                        this.getColeccionistas(this.paramsColeccionista)
                    }
                })
    }

    editarColeccionista(coleccionista: Coleccionista) {
        const dialog = this.dialog.open(FormActualizarColeccionistaComponent, {
            panelClass: ['w-full', 'md:w-5/12'],
            maxHeight: 'calc(100vh - 4rem)',
            disableClose:true,
            data: coleccionista
        }); 
    }

    getColeccionistas(params:any){
        this.coleccionistasService.getColeccionistas(params)
    }

    registrarBienCultural(coleccionista: DataColeccionista) {
        if (coleccionista) {
            this.router.navigate(
            [`bienes-culturales/registro/seccion/${coleccionista.coleccionista.seccion.tipologiaId}`],
            {
                queryParams: {
                coleccionista: coleccionista.coleccionista.codigoColeccionista,
                },
                queryParamsHandling: 'merge'
            }
            );
        } else {
            this.router.navigate([`bienes-culturales/registro/seccion/${coleccionista.coleccionista.seccion.tipologiaId}`]);
        }
    }

    eliminarColeccionista(coleccionista: Coleccionista) {
        this.utilsService.open_confirm_dialog(
            `Está seguro que desea Eliminar al Coleccionista ${coleccionista.nombre}`, 
            `Eliminar Coleccionista`
          )
        .subscribe(response=>{
            if (response === 'confirmed') {
                this.coleccionistasService.deleteColeccionista(coleccionista.coleccionistaUuid)
                .then((response) => {
                    this.utilsService.openSuccessSnakBar('Coleccionista eliminado correctamente')
                    this.getColeccionistas(this.paramsColeccionista)
                })
                .catch((error) => {
                    console.error('Error al eliminar el coleccionista:', error);
                });
            }
        })
    }    

    verBienesAsociados(coleccionista: DataColeccionista) {
        this.router.navigate( [`coleccionista/${coleccionista.coleccionista.coleccionistaUuid}/${coleccionista.coleccionista.coleccionistaId}`],)
    }
                

    ngOnDestroy() {
        if (this.coleccionistasSub) {
            this.coleccionistasSub.unsubscribe();
        }
    }

}